import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Chip, Stack, Typography } from "@mui/material";
import Loader from "@jumbo/components/Loader";
import { clearLeadMessages, getLeadMessages } from "app/redux/slice/leadSlice";

const ChatHistory = ({ leadId }) => {
  const dispatch = useDispatch();
  const { messages, messagesLoading } = useSelector((state) => state?.lead);

  useEffect(() => {
    if (leadId) {
      dispatch(getLeadMessages(leadId));
    }
    return () => {
      dispatch(clearLeadMessages());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadId]);

  if (messagesLoading) {
    return <Loader />;
  }

  if (!messages?.length) {
    return (
      <Typography variant="body1" sx={{ py: 3, textAlign: "center" }}>
        No messages yet.
      </Typography>
    );
  }

  return (
    <Stack spacing={1.5} sx={{ maxHeight: 420, overflowY: "auto", p: 1 }}>
      {messages.map((message) => (
        <Box
          key={message._id}
          sx={{
            alignSelf:
              message.direction === "outbound" ? "flex-end" : "flex-start",
            maxWidth: "75%",
            bgcolor:
              message.direction === "outbound" ? "primary.light" : "grey.100",
            borderRadius: 2,
            p: 1.5,
          }}
        >
          <Typography variant="body2">
            {message.messageText || `[${message.messageType}]`}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
            <Chip
              size="small"
              label={message.direction}
              variant="outlined"
            />
            <Typography variant="caption" color="text.secondary">
              {new Date(
                message.providerTimestamp || message.createdAt
              ).toLocaleString()}
            </Typography>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};

export default ChatHistory;
